import React from "react";
import PropTypes from "prop-types";

import { DropdownButton, NavItem } from "react-bootstrap";
import {
  IoFolder,
  IoTrash,
  IoEllipsisVertical,
  IoCheckmarkDoneCircle,
  IoArrowRedo
} from "react-icons/io5";

const TableActions = ({
  onClickView,
  onClickDelete,
  viewText,
  deleteText,
  onClickComplete,
  onClickFullView,
  fullViewText
}) => (
  <div className="actions">
    <DropdownButton
      id="dropdown"
      title={<IoEllipsisVertical />}
      style={{ fontWeight: "normal" }}
    >
      {onClickView && (
        <NavItem onClick={onClickView}>
          <IoFolder />
          {viewText || "View"}
        </NavItem>
      )}
      {onClickFullView && (
        <NavItem onClick={onClickFullView}>
          <IoArrowRedo />
          {fullViewText || "Full View"}
        </NavItem>
      )}
      {onClickComplete && (
        <NavItem onClick={onClickComplete}>
          <IoCheckmarkDoneCircle />
          Mark as Complete
        </NavItem>
      )}
      {onClickDelete && (
        <NavItem onClick={onClickDelete}>
          <IoTrash />
          {deleteText || "Delete"}
        </NavItem>
      )}
    </DropdownButton>
  </div>
);

TableActions.propTypes = {
  onClickView: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickComplete: PropTypes.func,
  viewText: PropTypes.string,
  deleteText: PropTypes.string,
  onClickFullView: PropTypes.func,
  fullViewText: PropTypes.string
};

export default TableActions;
